/* global google, bikehubMapping */

import log from './log' // eslint-disable-line
import _ from 'lodash'

export class BikehubMapping {
  // The page instance of this class is modified to store the current list of points for rendering
  constructor (page = 'default') {
    this.page = page
    this.searchBox = null
    this.searchMarkers = []
    this.markerPointsToRender = []
    this.markersRendered = []
    this.mapElementID = 'bikehubMap'
    this.wrapperElementID = ''
    this.mapControls = { mapType: false, streetView: false }
  }

  googleMapsLoaded () {
    return typeof google === 'object' && typeof google.maps === 'object'
  }

  loadMap (callback) {
    if (this.googleMapsLoaded()) {
      return callback()
    }
    // Add google maps script
    $.ajax({
      type: 'GET',
      url: `https://maps.googleapis.com/maps/api/js?key=${window.googleMapKey}&libraries=places`,
      success: callback,
      dataType: 'script',
      cache: true
    })
  }

  renderMap ({
    lat,
    lng,
    zoom,
    storeLocation = true,
    renderAddressSearch = true
  }) {
    // log.debug(
    //   `rendering map: { lat: ${lat}, lng: ${lng}, zoom: ${zoom}, storeLocation: ${storeLocation}, renderAddressSearch: ${renderAddressSearch} }`
    // );

    if (!window.infoWindow) {
      window.infoWindow = new google.maps.InfoWindow()
    }
    // This is a little bit of a hack to make autoresize happen
    if ($('#fullscreenMap').length) {
      this.makeMapFullscreen()
      $(window).on('resize', this.makeMapFullscreen)
    }
    window.bikehubMap = new google.maps.Map(
      document.getElementById(this.mapElementID),
      {
        // Our mapping options
        zoom: zoom,
        center: new google.maps.LatLng(lat, lng),
        gestureHandling: 'cooperative',
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        mapTypeControl: this.mapControls.mapType,
        streetViewControl: this.mapControls.streetView
      }
    )
    // If we're suppose to include the address search, do it
    if (renderAddressSearch) {
      this.renderAddressSearch()
    }
    if (this.wrapperElementID.length) {
      // There are certain things that only should show up once the map is rendered, to prevent flashing/movement
      // So pause to prevent flash where it loads in the wrong place, and ensure map is rendered
      window.setTimeout(
        () => $(`#${this.wrapperElementID}`).addClass('mapRendered'),
        500
      )
    }
  }

  makeMapFullscreen () {
    $('#fullscreenMap #bikehubMap').css('height', `${$(window).height()}px`)
  }

  storedViewportKey () {
    return `bikehubMapping-${this.page}`
  }

  storeViewport () {
    const viewport = this.currentViewport()
    localStorage.setItem(this.storedViewportKey(), JSON.stringify(viewport))
    return viewport
  }

  storedViewport () {
    const stored = localStorage.getItem(this.storedViewportKey())
    return !stored ? stored : JSON.parse(stored)
  }

  removeStoredViewport () {
    localStorage.removeItem(this.storedViewportKey())
  }

  currentViewport () {
    return {
      zoom: window.bikehubMap.getZoom(),
      lat: window.bikehubMap.center.lat(),
      lng: window.bikehubMap.center.lng(),
      at: new Date().getTime()
    }
  }

  fitMap () {
    const bounds = new google.maps.LatLngBounds()
    // Fit to markers
    for (const marker of Array.from(this.markersRendered)) {
      if (marker) {
        bounds.extend(marker.getPosition())
      }
    }
    window.bikehubMap.fitBounds(bounds)

    // Finish rendering map, then check - if too zoomed in (e.g. on one point), zoom out
    window.setTimeout(function () {
      if (window.bikehubMap.zoom > 16) {
        window.bikehubMap.setZoom(16)
      }
    }, 500)
  }

  renderAddressSearch () {
    if (window.bikehubMap.searchBox != null) {
      return true
    }
    $(`#${this.mapElementID}`).before(
      '<input id="placeSearch" class="controls form-control" type="text" placeholder="Search map">'
    )
    const input = document.getElementById('placeSearch')
    bikehubMapping.searchBox = new google.maps.places.SearchBox(input)
    window.bikehubMap.controls[google.maps.ControlPosition.TOP_RIGHT].push(
      input
    )
    // Bias SearchBox results towards current map's viewport.
    window.bikehubMap.addListener('bounds_changed', () =>
      bikehubMapping.searchBox.setBounds(window.bikehubMap.getBounds())
    )

    bikehubMapping.searchBox.addListener('places_changed', function () {
      const places = bikehubMapping.searchBox.getPlaces()
      if (places.length === 0) {
        log.debug('Unable to find that address')
      }
      // For each place, get the icon, name and location.
      const bounds = new google.maps.LatLngBounds()
      places.forEach(function (place) {
        if (!place.geometry) {
          log.debug('Returned place contains no geometry')
        }
        // Create a marker for each place
        bikehubMapping.searchMarkers.push(
          new google.maps.Marker({
            map: window.bikehubMap,
            icon:
              'http://maps.google.com/mapfiles/ms/micons/purple-pushpin.png',
            title: place.name,
            position: place.geometry.location
          })
        )
        bounds.extend(place.geometry.location)
      })
      window.bikehubMap.fitBounds(bounds)
    })
  }

  clearMarkers () {
    if (!bikehubMapping.markersRendered) {
      bikehubMapping.markersRendered = []
    }

    if (window.infoWindow != null) {
      window.infoWindow.close()
    }
    // Useful when the page reloads without fully reloading
    if (bikehubMapping.markersRendered.length) {
      for (const i of Array.from(bikehubMapping.markersRendered)) {
        i != null && i.setMap(null)
      }
    }
    bikehubMapping.markersRendered = []
    // Ids make sure we aren't double rendering
    return (window.renderedMarkerIds = [])
  }

  markersInViewport () {
    const bounds = window.bikehubMap.getBounds()
    return this.markersRendered.filter(m => bounds.contains(m.getPosition()))
  }

  iconForMarker (point) {
    return window.bikehubLocations.iconForPoint(point)
  }

  renderMarkerWindow (point) {
    let popupContent = ''
    if (this.page === 'locations') {
      popupContent = window.bikehubLocations.markerMapPopup(point)
    } else {
      popupContent = `Missing template for "${this.page}" maps`
    }
    window.infoWindow.setContent(popupContent)
    // Ensure things are rendered before setting times, pause for a hot sec
    window.setTimeout(() => window.timeParser.localize(), 50)
  }

  openInfoWindow (marker, markerId, point) {
    window.infoWindow.setContent('')
    window.infoWindow.open(window.bikehubMap, marker)
    this.enableEscapeForInfoWindows()
    // For an unclear reason, this needs to return the rendered marker
    return this.renderMarkerWindow(point)
  }

  enableEscapeForInfoWindows () {
    // Enable using escape key to close info windows
    // Make sure we aren't adding duplicate handlers, sometimes we don't catch the close event
    $(window).off('keyup')
    // Add the trigger for the escape closing the window
    $(window).on('keyup', function (e) {
      if (e.keyCode === 27) {
        window.infoWindow.close()
        // Escape was pressed, infoWindow is closed, so remove the keyup handler
        $(window).off('keyup')
      }
      return true // allow bubbling up
    })
    // on infowindow close, remove keyup handler - aka clean up after yourself
    google.maps.event.addListener(window.infoWindow, 'closeclick', function () {
      $(window).off('keyup')
    })
  }

  addMarkers ({ fitMap = false, callback = null }) {
    // log.debug(`adding markers - fitMap: ${fitMap}`);
    while (this.markerPointsToRender.length > 0) {
      const point = this.markerPointsToRender.shift()
      const markerId = point.id
      const icon = this.iconForMarker(point)
      if (_.find(this.markersRendered, ['id', markerId])) {
        log.debug(`already rendered point: ${markerId}`)
      } else if (icon.length < 1) {
        log.debug(`marker: ${markerId} has no icon`)
      } else {
        const marker = new google.maps.Marker({
          position: new google.maps.LatLng(point.lat, point.lng),
          map: window.bikehubMap,
          kind: point.kind,
          icon: {
            url: icon,
            scaledSize: new google.maps.Size(50, 50)
          },
          ourId: markerId
        })

        google.maps.event.addListener(
          marker,
          'click',
          ((marker, markerId) =>
            function () {
              return bikehubMapping.openInfoWindow(marker, markerId, point)
            })(marker, markerId)
        )
        this.markersRendered.push(marker)
      }
    }
    // If we're suppose to fit the map to the markers - and if there are markers that have been rendered - fit it
    if (fitMap === true && this.markersRendered.length > 0) {
      // log.debug("fitting map");
      this.fitMap()
    }
    if (callback !== undefined && callback !== null) {
      // log.debug("calling back from addMarkers");
      callback()
    }
  }
}
